import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { InstructionVideoUploadDialog } from './instruction-video-upload.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,
  ],
  declarations: [InstructionVideoUploadDialog],
  exports: [InstructionVideoUploadDialog],
})
export class InstructionVideoUploadModule { }
